export default {
  data() {
    return {
      errorMessage: '',
      errorAlert: false,
      loading: true,
    };
  },
  methods: {
    displayError(messageCode, p) {
      this.errorMessage = this.$t(`error.${messageCode}`);
      if (p) this.errorMessage = this.$t(`error.${messageCode}`, { p });
      this.errorAlert = true;
      this.loading = false;
    },
    clearError() {
      this.errorAlert = false;
    },
  },
};
